"use strict";
// (C) 2021-2022 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.useToastMessage = void 0;
var tslib_1 = require("tslib");
var react_1 = require("react");
var react_intl_1 = require("react-intl");
var ToastMessageContext_1 = require("./ToastMessageContext");
/**
 * @internal
 */
exports.useToastMessage = function () {
    var _a = react_1.useContext(ToastMessageContext_1.ToastMessageContext), addMessage = _a.addMessage, removeMessage = _a.removeMessage, removeAllMessages = _a.removeAllMessages;
    var intl = react_intl_1.useIntl();
    var addMessageBase = function (type) {
        return function (message, options) {
            if (options === null || options === void 0 ? void 0 : options.values) {
                return addMessage(tslib_1.__assign(tslib_1.__assign({}, options), { type: type, node: intl.formatMessage(message, options.values) }));
            }
            return addMessage(tslib_1.__assign(tslib_1.__assign({}, options), { type: type, text: intl.formatMessage(message) }));
        };
    };
    var addSuccess = addMessageBase("success");
    var addProgress = addMessageBase("progress");
    var addWarning = addMessageBase("warning");
    var addError = addMessageBase("error");
    return {
        addSuccess: addSuccess,
        addProgress: addProgress,
        addWarning: addWarning,
        addError: addError,
        removeMessage: removeMessage,
        removeAllMessages: removeAllMessages,
    };
};
//# sourceMappingURL=useToastMessage.js.map